import { render, staticRenderFns } from "./PrettyRouteLink.vue?vue&type=template&id=3ebf2cf4&scoped=true"
import script from "./PrettyRouteLink.vue?vue&type=script&lang=js"
export * from "./PrettyRouteLink.vue?vue&type=script&lang=js"
import style0 from "./PrettyRouteLink.vue?vue&type=style&index=0&id=3ebf2cf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebf2cf4",
  null
  
)

export default component.exports